// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { TabProps as MuiTabProps, Tab as TabComponent } from '@mui/material';
import { FC } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Tab as RaTab, TabProps } from 'react-admin';

export const Tab: FC<TabProps> = (props) => <RaTab {...props} tabIndex={0} />;

export const MuiTab: FC<MuiTabProps> = (props) => <TabComponent {...props} tabIndex={0} />;
